// extracted by mini-css-extract-plugin
module.exports = {"data-chip__label":"DataChip_data-chip__label__1ey45","data-chip__value":"DataChip_data-chip__value__4-oiK","data-chip__value--large":"DataChip_data-chip__value--large__2CVrI"};